// Mobile menu focus handling lives in mobile-navigation.js.
const initHeader2026Menus = () => {
  const stickyMenus = Array.from(
    document.querySelectorAll(
      ".header-2026 .sticky-menu, .header-2026 #sticky-menu"
    )
  );

  if (stickyMenus.length === 0) return;

  const compactClassName = "is-compact";
  const compactThresholdPx = 14;
  let compactStateTicking = false;

  const updateCompactMenus = () => {
    compactStateTicking = false;
    const shouldCompact = window.scrollY > compactThresholdPx;

    stickyMenus.forEach((menu) => {
      menu.classList.toggle(compactClassName, shouldCompact);
    });
  };

  const queueCompactUpdate = () => {
    if (compactStateTicking) return;
    compactStateTicking = true;
    window.requestAnimationFrame(updateCompactMenus);
  };

  updateCompactMenus();
  window.addEventListener("scroll", queueCompactUpdate, { passive: true });
  window.addEventListener("resize", queueCompactUpdate, { passive: true });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeader2026Menus);
} else {
  initHeader2026Menus();
}
